export default {"src":"/_next/static/media/tg_logo.a05c713e.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};